"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccountContext = exports.useAccount = exports.AccountContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Api = __importStar(require("@src/api"));
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const types_1 = require("@src/types");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const socket_context_1 = require("./socket-context");
const AccountContext = react_1.default.createContext({
    account: null,
    isAccountLoading: false,
    refetchAccount: (async () => { }),
});
const AccountContextProvider = ({ children }) => {
    var _a;
    const intl = (0, react_intl_1.useIntl)();
    const history = (0, react_router_1.useHistory)();
    const socket = (0, socket_context_1.useSocket)();
    const { data: account, isLoading: isAccountLoading, refetch } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.account.key, []);
    const { mutateAsync: verify } = (0, useAppMutation_1.useAppMutation)(Api.Account.verifyAccount, {
        onSuccess: data => {
            antd_1.notification.success({
                message: intl.formatMessage({ id: 'general.notice' }),
                description: intl.formatMessage({ id: 'account.verification.success' }),
            });
            socket.emit(types_1.SocketEvents.ACCOUNT_VERIFIED, data);
            refetch();
        },
        onError: (error) => {
            var _a;
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 304) {
                antd_1.notification.warning({
                    message: intl.formatMessage({ id: 'general.notice' }),
                    description: intl.formatMessage({ id: 'account.verification.error.already_verified' }),
                });
            }
        },
    });
    // refetchOnWindowFocus functionality
    // to refresh the verified status of the account
    // in the old tab if user uses that instead of the new
    // (when they are coming from the email)
    react_1.default.useEffect(() => {
        const handleFocus = () => {
            refetch();
        };
        window.addEventListener('focus', handleFocus);
        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, [refetch]);
    react_1.default.useEffect(() => {
        // Email Verification Token === evt
        if (history === null || history === void 0 ? void 0 : history.getQuery().evt) {
            verify({ verificationToken: history.getQuery().evt });
        }
    }, [(_a = history === null || history === void 0 ? void 0 : history.location) === null || _a === void 0 ? void 0 : _a.pathname]);
    return ((0, jsx_runtime_1.jsx)(AccountContext.Provider, { value: { account, isAccountLoading, refetchAccount: refetch }, children: children }));
};
exports.AccountContextProvider = AccountContextProvider;
const useAccount = () => {
    const context = react_1.default.useContext(AccountContext);
    if (!context) {
        throw Error('AccountContext hook can be used only inside AccountContextProvider');
    }
    return context.account;
};
exports.useAccount = useAccount;
const useAccountContext = () => {
    const context = react_1.default.useContext(AccountContext);
    if (!context) {
        throw Error('AccountContext hook can be used only inside AccountContextProvider');
    }
    return context;
};
exports.useAccountContext = useAccountContext;
